module.exports = __webpack_public_path__ + "089f37e8ad2e9dcab96d8d752c640bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-420.jpg
// module id = 344
// module chunks = 0